export default __webpack_public_path__ + "static/media/BankIcon.f7969ec3.svg";